import { render, staticRenderFns } from "./MostrarInforme.vue?vue&type=template&id=165e1c32&scoped=true"
import script from "./MostrarInforme.vue?vue&type=script&lang=js"
export * from "./MostrarInforme.vue?vue&type=script&lang=js"
import style0 from "./MostrarInforme.vue?vue&type=style&index=0&id=165e1c32&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "165e1c32",
  null
  
)

export default component.exports